import * as React from 'react';
import './index.css';
import { widget } from '../../charting_library/charting_library.min';
import Datafeed from './api/'

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

//console.log(window.location.pathname.split('/'))

let inter = (typeof window.location.href.split('?')[1] == "undefined" || window.location.href.split('?')[1] == "")? '1' : window.location.href.split('?')[1];

export class TVChartContainer extends React.PureComponent {
	tvWidget = null;

	static defaultProps = {
		// 소켓스트림에서 symobl부분을 적절히 처리해두면 
		// 차트에 표시되는 종목명을 원하는대로 설정할 수 있음
		//symbol: 'FXCM:USOil/1',
		symbol: 'PEPPERSTONE:XAUUSD/1',
		interval: inter,
		timezone: 'Asia/Seoul',
		containerId: 'tv_chart_container',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		autosize: true,
		studiesOverrides: {},
		overrides: {
			"paneProperties.background": "#131722",
			"paneProperties.vertGridProperties.color": "#363c4e",
			"paneProperties.horzGridProperties.color": "#363c4e",
			"symbolWatermarkProperties.transparency": 90,
			"scalesProperties.textColor" : "#AAA",
			"mainSeriesProperties.candleStyle.wickUpColor": '#336854',
			"mainSeriesProperties.candleStyle.wickDownColor": '#7f323f',
		   }
	};

	componentDidMount() {
		const widgetOptions = {
			debug: false,
			symbol: this.props.symbol,
			datafeed: Datafeed,
			interval: this.props.interval,
			container_id: this.props.containerId,
			library_path: this.props.libraryPath,
			locale: getLanguageFromURL('lang') || "ko",
			favorites: {
				//intervals: ["1","2","5"]
			},
			disabled_features: [
				/*'use_localstorage_for_settings',
				'header_widget',
				'header_symbol_search',
				'header_widget_dom_node', 
				'source_selection_markers', 
				'adaptive_logo', 
				'constraint_dialogs_movement',
				'header_interval_dialog_button',
				'show_interval_dialog_on_key_press',
				'symbol_search_hot_key',
				'study_dialog_search_control',
				'display_market_status',
				'header_chart_type', 
				'header_compare', 
				'header_undo_redo', 
				'header_screenshot', 
				'volume_force_overlay', 
				'header_settings', 
				'property_pages', 
				'header_fullscreen_button', 
				'header_saveload',
				'edit_buttons_in_legend',
				'symbol_info',
				'border_around_the_chart',
				'main_series_scale_menu',
				'star_some_intervals_by_default',
				'datasource_copypaste',
				'right_bar_stays_on_scroll',
				'context_menus',
				'go_to_date',
				'compare_symbol',
				'border_around_the_chart',
				'timezone_menu',
				'left_toolbar',
				'control_bar',
				'edit_buttons_in_legend', 
				'remove_library_container_border',*/
				'timeframes_toolbar', 
			],
			//enabled_features: ['study_templates'],
			charts_storage_url: this.props.chartsStorageUrl,
			charts_storage_api_version: this.props.chartsStorageApiVersion,
			client_id: this.props.clientId,
			user_id: this.props.userId,
			fullscreen: this.props.fullscreen,
			autosize: this.props.autosize,
			studies_overrides: this.props.studiesOverrides,
			overrides: {
				"symbolWatermarkProperties.transparency": 90,
				"scalesProperties.textColor" : "#AAA",
				"mainSeriesProperties.candleStyle.wickUpColor": '#f44336',
				"mainSeriesProperties.candleStyle.wickDownColor": '#2196f3',
				"mainSeriesProperties.candleStyle.borderUpColor": '#f44336',
				"mainSeriesProperties.candleStyle.borderDownColor": '#2196f3',
				"mainSeriesProperties.candleStyle.upColor": "#f44336",
				"mainSeriesProperties.candleStyle.downColor": "#2196f3",
			},
			volume_precision: 8,
			data_status: 'streaming',
		};

		const tvWidget = new widget(widgetOptions);
		this.tvWidget = tvWidget;
		const thisComponent = this;

		tvWidget.onChartReady(() => {
			tvWidget.headerReady().then(() => {
				const button = tvWidget.createButton();
				button.setAttribute('title', 'Click to show a notification popup');
				button.classList.add('apply-common-tooltip');
				button.addEventListener('click', () => tvWidget.showNoticeDialog({
					title: 'Notification',
					body: 'TradingView Charting Library API works correctly',
					callback: () => {
						console.log('Noticed!');
					},
				}));

				//button.innerHTML = 'Check API';
				
				tvWidget.chart().onIntervalChanged().subscribe(null, function(interval, obj) {
					console.log('On interval change')
				})

				tvWidget.chart().onSymbolChanged().subscribe(null, function(symbolData) {
					console.log('Symbol change ' + symbolData)
				})
			});
		});
	}

	render() {
		return (
			<div
				id={ this.props.containerId }
				className={ 'TVChartContainer' }
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/index.jsx